import React, { useEffect, useState, useContext } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Flex, useToast, HStack, Button } from "@chakra-ui/react";
import ClientData from "./ClientData";
import OrderData from "./OrderData";
import ProductList from "./ProductList";
import useFetch from "../../../hooks/useFetch";
import Body from "../../Common/Body";
import { OrdersContext } from "../../Context/OrdersContext";
import { ProductsContext } from "../../Context/ProductsContext";
import ConfirmationSwal from "../../../Utils/confirmationSwal";

const OrderManager = () => {
  const { getProducts } = useContext(ProductsContext);
  const [order, setOrder] = useState({});
  const [priceListsProducts, setPriceListsProducts] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const paramOrderId = useParams().id;
  const { deleteOrder } = useContext(OrdersContext);
  const history = useHistory();
  const { get, put } = useFetch();

  const fetchData = async () => {
    let orderData = await get(`/orders/${paramOrderId}`);
    setOrder(orderData);

    get(`/users/${orderData.userId}/admin/price-lists?orderBy=productName`)
      .then(async (res) => {
        setPriceListsProducts(res);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setisLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);
  const toast = useToast();

  const setProducts = async (newProducts) => {
    let newOrder = { ...order };
    newOrder.products = newProducts;
    setOrder(newOrder);

    toast({
      title: "Edicion de pedido",
      description: "Pedido editado con éxito.",
      status: "success",
      duration: 4000,
      isClosable: true,
    });
  };

  const updateOrder = (field, successMsg = null) => {
    put("/orders", { ordersId: [order.id], ...field })
      .then((res) => {
        setOrder(res.orders[0]);
        successMsg &&
          toast({
            title: "Edicion de pedido",
            description: successMsg,
            status: "success",
            duration: 4000,
            isClosable: true,
          });
        getProducts({ orderBy: "productName" });
      })
      .catch((error) => {
        toast({
          title: "Se ha producido un error.",
          description:
            error?.message || "Contacte con el administrador del sistema.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const setStatus = (status) => {
    updateOrder(
      {
        statusId: status,
      },
      "Estado editado con éxito."
    );
  };

  const updatePrints = () => {
    updateOrder({
      prints: order.prints + 1,
    });
  };

  const updateConfirmation = () => {
    updateOrder({
      confirmations: order.confirmations + 1,
    });
  };

  const deleteOrderHandler = () => {
    ConfirmationSwal.fire({
      title: "Eliminar pedido",
      text: "¿Está seguro que desea eliminar el pedido?",
      icon: "question",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteOrder(order.id);
          toast({
            title: "Pedido eliminado con éxito.",
            status: "success",
            duration: 4000,
            isClosable: true,
          });
          history.push("/pedidos");
        } catch (e) {
          toast({
            title: "Se ha producido un error.",
            description:
              e?.message || "Contacte con el administrador del sistema.",
            status: "error",
            duration: 4000,
            isClosable: true,
          });
        }
      }
    });
  };

  return (
    <Body title={`Pedido ${order.id}`} isLoading={isLoading}>
      <Flex justifyContent="space-between" direction={["column", "row"]}>
        <OrderData
          order={order}
          setNewStatus={setStatus}
          updatePrints={updatePrints}
          updateConfirmation={updateConfirmation}
        ></OrderData>
        <ClientData order={order}></ClientData>
      </Flex>
      <ProductList
        priceListsProducts={priceListsProducts}
        orderProducts={order.products}
        setProducts={setProducts}
        orderId={order.id}
        editable={order.statusId < 3 ? true : false}
      ></ProductList>
      <HStack
        justify={["center", "flex-end"]}
        mt="2rem"
        wrap={"wrap"}
        gap="0.5rem"
      >
        <Button colorScheme="red" onClick={() => deleteOrderHandler()}>
          Eliminar
        </Button>
      </HStack>
    </Body>
  );
};

export default OrderManager;
